var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"time-line__wrapper"},_vm._l((_vm.dates),function(date,index){return _c('div',{key:`timeLinePoint${index}`,staticClass:"point"},[_c('img',{attrs:{"src":`/assets/icons/${(index + 1) === _vm.dates.length ? 'circle_achievement' : 'circle-circle'}.svg`}})])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }